import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUser,
  faChartBar,
  faChartPie,
  faTimesCircle,
  faBuilding,
  faBroadcastTower,
  faUserCog,
  faFileInvoiceDollar,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

import { type, userid } from "../common/AdminAuth";

const DashboardSideMenu = () => {
  const [pName, setPName] = useState("");
  const [openGroups, setOpenGroups] = useState({});

  const checkActive = (match, location) => {
    if (!location) return false;
    const { pathname } = location;
    //console.log("location", location);
    setPName(pathname);
  };

  const menuHideShow = () => {
    let menubar = document.getElementById("mobile-menu");
    menubar.classList.remove("layout-menu-expanded");
  };

  const isGroupActive = (routeChecks) =>
    routeChecks.some((check) => pName.includes(check));

  const isGroupOpen = (key, routeChecks) =>
    openGroups[key] !== undefined ? openGroups[key] : isGroupActive(routeChecks);

  const toggleGroup = (key, routeChecks) => {
    setOpenGroups((prev) => ({
      ...prev,
      [key]: !isGroupOpen(key, routeChecks),
    }));
  };

  const userReportRoutes = [
    "/admin/summary-report",
    "/admin/details-report",
    "/admin/summary-date-wise",
    "/admin/global-search",
  ];
  const companyRoutes = ["vendor", "company"];
  const routeMgmtRoutes = ["all-route" , "country-pricing"];
  const smscRoutes = ["/admin/smsc-report", "/admin/add-smsc", "/admin/esme-report"];
  const userMgmtRoutes = [
    "/admin/user-list",
    "/admin/add-user",
    "assigned",
    "/admin/balance-history",
  ];
  const managerRoutes = ["/admin/manager"];
  const billingRoutes = ["/admin/customer-billing", "/admin/vendor-billing"];
  const myAccountRoutes = ["/admin/manager/rate-route-list"];
  const downloadRoutes = ["/admin/download-request", "/admin/download-list"];

  useEffect(() => {
    const groups = [
      { key: "myAccount", routes: myAccountRoutes },
      { key: "userReport", routes: userReportRoutes },
      { key: "company", routes: companyRoutes },
      { key: "route", routes: routeMgmtRoutes },
      { key: "smsc", routes: smscRoutes },
      { key: "userMgmt", routes: userMgmtRoutes },
      { key: "manager", routes: managerRoutes },
      { key: "billing", routes: billingRoutes },
      { key: "download", routes: downloadRoutes },
    ];
    const activeGroup = groups.find((g) =>
      g.routes.some((r) => pName.includes(r))
    );
    if (activeGroup) {
      setOpenGroups((prev) =>
        prev[activeGroup.key] ? prev : { ...prev, [activeGroup.key]: true }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pName]);

  return (
    <div id="mobile-menu">
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme"
      >
        <div className="app-brand demo">
          <span className="app-brand-text demo menu-text fw-bolder ms-2">
            SMPP{" "}
          </span>
          <button className="menu-btn" onClick={menuHideShow}>
            {" "}
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        </div>
        <ul className="menu-inner py-1">
          <li className={pName === "/admin" ? "menu-item active" : "menu-item"}>
            <NavLink className="menu-link" isActive={checkActive} to="/admin">
              <FontAwesomeIcon
                className="menu-icon tf-icons bx bx-home-circle"
                icon={faHome}
              />
              <div data-i18n="Analytics"> Dashboard </div>
            </NavLink>
          </li>

          {/* My Account */}
          {type === "Manager" || type === "Emp" ? (
            <li
              className={
                isGroupOpen("myAccount", myAccountRoutes)
                  ? "menu-item open"
                  : "menu-item"
              }
            >
              <a
                href="javascript:void(0);"
                className="menu-link menu-toggle"
                onClick={() => toggleGroup("myAccount", myAccountRoutes)}
              >
                <FontAwesomeIcon icon={faUserCog} className="menu-icon tf-icons mr-2" />
                <div data-i18n="Support">My Account</div>
              </a>
              <ul className="menu-sub">
                <li
                  className={
                    pName.includes("/admin/manager/rate-route-list")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link
                    to={`/admin/manager/rate-route-list/${userid}`}
                    className="menu-link"
                  >
                    <div data-i18n="Support">Route List</div>
                  </Link>
                </li>
              </ul>
            </li>
          ) : null}

          {/* User Report */}
          <li
            className={
              isGroupOpen("userReport", userReportRoutes)
                ? "menu-item open"
                : "menu-item"
            }
          >
            <a
              href="javascript:void(0);"
              className="menu-link menu-toggle"
              onClick={() => toggleGroup("userReport", userReportRoutes)}
            >
              <FontAwesomeIcon
                className="menu-icon tf-icons bx bx-home-circle"
                icon={faChartPie}
              />
              <div data-i18n="Basic"> User Report </div>
            </a>
            <ul className="menu-sub">
              <li
                className={
                  pName.includes("/admin/summary-report")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/admin/summary-report" className="menu-link">
                  <div data-i18n="Basic"> Summary Report </div>
                </Link>
              </li>
              <li
                className={
                  pName.includes("/admin/details-report")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/admin/details-report" className="menu-link">
                  <div data-i18n="Basic"> Details Report </div>
                </Link>
              </li>
              <li
                className={
                  pName.includes("/admin/summary-date-wise")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/admin/summary-date-wise" className="menu-link">
                  <div data-i18n="Basic"> Date Wise Report </div>
                </Link>
              </li>
              {type === "Admin" && (
                <li
                  className={
                    pName === "/admin/global-search"
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/global-search" className="menu-link">
                    <div data-i18n="Basic"> Global Search </div>
                  </Link>
                </li>
              )}
            </ul>
          </li>

          {/* Company Management */}
          <li
            className={
              isGroupOpen("company", companyRoutes)
                ? "menu-item open"
                : "menu-item"
            }
          >
            <a
              href="javascript:void(0);"
              className="menu-link menu-toggle"
              onClick={() => toggleGroup("company", companyRoutes)}
            >
              <FontAwesomeIcon icon={faBuilding} className="menu-icon tf-icons mr-2" />
              <div data-i18n="Support">Company Management</div>
            </a>
            <ul className="menu-sub">
              <li
                className={
                  pName.includes("vendor") ? "menu-item active" : "menu-item"
                }
              >
                <Link to="/admin/vendor" className="menu-link">
                  <div data-i18n="Support">Vendor Customer </div>
                </Link>
              </li>
              <li
                className={
                  pName.includes("company") ? "menu-item active" : "menu-item"
                }
              >
                <Link to="/admin/company" className="menu-link">
                  <div data-i18n="Support">Add Customer Company</div>
                </Link>
              </li>
            </ul>
          </li>

          {/* Route Management */}
          <li
            className={
              isGroupOpen("route", routeMgmtRoutes)
                ? "menu-item open"
                : "menu-item"
            }
          >
            <a
              href="javascript:void(0);"
              className="menu-link menu-toggle"
              onClick={() => toggleGroup("route", routeMgmtRoutes)}
            >
              <FontAwesomeIcon icon={faBroadcastTower} className="menu-icon tf-icons mr-2" />
              <div data-i18n="Support">Route Management</div>
            </a>
            <ul className="menu-sub">
              <li
                className={
                  pName.includes("all-route") ? "menu-item active" : "menu-item"
                }
              >
                <Link to="/admin/all-route" className="menu-link">
                  <div data-i18n="Support">All Route </div>
                </Link>
              </li>
            </ul>

             <ul className="menu-sub">
              <li
                className={
                  pName.includes("country-pricing") ? "menu-item active" : "menu-item"
                }
              >
                <Link to="/admin/country-pricing" className="menu-link">
                  <div data-i18n="Support">Country Pricing</div>
                </Link>
              </li>
            </ul>
          </li>

          {/* SMSC Report */}
          {type === "Admin" ? (
            <li
              className={
                isGroupOpen("smsc", smscRoutes) ? "menu-item open" : "menu-item"
              }
            >
              <a
                href="javascript:void(0);"
                className="menu-link menu-toggle"
                onClick={() => toggleGroup("smsc", smscRoutes)}
              >
                <FontAwesomeIcon
                  className="menu-icon tf-icons bx bx-home-circle"
                  icon={faChartBar}
                />
                <div data-i18n="Basic"> SMSC Report </div>
              </a>
              <ul className="menu-sub">
                <li
                  className={
                    pName === "/admin/smsc-report" || pName === "/admin/add-smsc"
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/smsc-report" className="menu-link">
                    <div data-i18n="Basic"> SMSC Report </div>
                  </Link>
                </li>
                <li
                  className={
                    pName === "/admin/esme-report"
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/esme-report" className="menu-link">
                    <div data-i18n="Basic"> ESME Report </div>
                  </Link>
                </li>

                {/* <li
                  className={
                    pName === "/admin/smsc-report-ec2" ||
                      pName === "/admin/add-smsc"
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/smsc-report-ec2" className="menu-link">
                    <FontAwesomeIcon
                      className="menu-icon tf-icons bx bx-home-circle"
                      icon={faChartBar}
                    />
                    <div data-i18n="Basic"> SMSC Report EC2 </div>
                  </Link>
                </li> */}
                {/* <li
                  className={
                    pName === "/admin/esme-report-ec2"
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/esme-report-ec2" className="menu-link">
                    <FontAwesomeIcon
                      className="menu-icon tf-icons bx bx-home-circle"
                      icon={faChartLine}
                    />
                    <div data-i18n="Basic"> ESME Report EC2 </div>
                  </Link>
                </li> */}
              </ul>
            </li>
          ) : null}

          {/* User Management */}
          <li
            className={
              isGroupOpen("userMgmt", userMgmtRoutes)
                ? "menu-item open"
                : "menu-item"
            }
          >
            <a
              href="javascript:void(0);"
              className="menu-link menu-toggle"
              onClick={() => toggleGroup("userMgmt", userMgmtRoutes)}
            >
              <FontAwesomeIcon
                className="menu-icon tf-icons bx bx-home-circle"
                icon={faUser}
              />
              <div data-i18n="Basic">User Management</div>
            </a>
            <ul className="menu-sub">
              <li
                className={
                  pName.includes("/admin/user-list") ||
                  pName.includes("/admin/add-user")
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/admin/user-list" className="menu-link">
                  <div data-i18n="Basic">All User list </div>
                </Link>
              </li>

              <li
                className={
                  pName.includes("assigned") ? "menu-item active" : "menu-item"
                }
              >
                <Link to="/admin/user-assigned-route" className="menu-link">
                  <div data-i18n="Basic"> User Assigned Route </div>
                </Link>
              </li>

              <li
                className={
                  pName === "/admin/balance-history"
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/admin/balance-history" className="menu-link">
                  <div data-i18n="Basic"> Balance History </div>
                </Link>
              </li>
            </ul>
          </li>

          {/* Manager Add / List */}
          {type === "Admin" ? (
            <li
              className={
                isGroupOpen("manager", managerRoutes)
                  ? "menu-item open"
                  : "menu-item"
              }
            >
              <a
                href="javascript:void(0);"
                className="menu-link menu-toggle"
                onClick={() => toggleGroup("manager", managerRoutes)}
              >
                <FontAwesomeIcon icon={faUserCog} className="menu-icon tf-icons mr-2" />
                <div data-i18n="Support">Manager Add / List</div>
              </a>
              <ul className="menu-sub">
                <li
                  className={
                    pName === "/admin/manager" ? "menu-item active" : "menu-item"
                  }
                >
                  <Link to="/admin/manager" className="menu-link">
                    <div data-i18n="Support">Manager</div>
                  </Link>
                </li>
              </ul>
            </li>
          ) : null}

          {/* Billing */}
          {type === "Admin" ? (
            <li
              className={
                isGroupOpen("billing", billingRoutes)
                  ? "menu-item open"
                  : "menu-item"
              }
            >
              <a
                href="javascript:void(0);"
                className="menu-link menu-toggle"
                onClick={() => toggleGroup("billing", billingRoutes)}
              >
                <FontAwesomeIcon icon={faFileInvoiceDollar} className="menu-icon tf-icons mr-2" />
                <div data-i18n="Support">Billing</div>
              </a>
              <ul className="menu-sub">
                <li
                  className={
                    pName.includes("/admin/customer-billing")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/customer-billing" className="menu-link">
                    <div data-i18n="Support">Customer Billing</div>
                  </Link>
                </li>

                <li
                  className={
                    pName.includes("/admin/vendor-billing")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/vendor-billing" className="menu-link">
                    <div data-i18n="Support">Vendor Billig</div>
                  </Link>
                </li>
              </ul>
            </li>
          ) : null}

          {/* Download */}
          {type === "Admin" ? (
            <li
              className={
                isGroupOpen("download", downloadRoutes)
                  ? "menu-item open"
                  : "menu-item"
              }
            >
              <a
                href="javascript:void(0);"
                className="menu-link menu-toggle"
                onClick={() => toggleGroup("download", downloadRoutes)}
              >
                <FontAwesomeIcon icon={faDownload} className="menu-icon tf-icons mr-2" />
                <div data-i18n="Support">Download</div>
              </a>
              <ul className="menu-sub">
                <li
                  className={
                    pName.includes("/admin/download-request")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/download-request" className="menu-link">
                    <div data-i18n="Support">Request</div>
                  </Link>
                </li>

                <li
                  className={
                    pName.includes("/admin/download-list")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  <Link to="/admin/download-list" className="menu-link">
                    <div data-i18n="Support">List</div>
                  </Link>
                </li>
              </ul>
            </li>
          ) : null}
        </ul>
      </aside>
    </div>
  );
};

export default DashboardSideMenu;
